invalidWatcherResult